// An agency's white-label colours (super admin > location_config) on top of the studio
// tokens (theme/tokens.css). Decision 2026-10-21: agency colours replace the studio's
// action, navigation, page and card colours; type, spacing and layout stay the studio's.
import { getReadableTextColor } from 'utils/contrast'

const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i
const NAV_BG = '#ffffff' // --lj-nav-bg in tokens.css
const color = (v) => (typeof v === 'string' && HEX.test(v.trim()) ? v.trim() : null)

// Darken a #rrggbb colour by `amount` (0..1) for hover states.
const shade = (hex, amount = 0.14) => {
  const full = hex.length === 4 ? '#' + [...hex.slice(1)].map((c) => c + c).join('') : hex
  const n = parseInt(full.slice(1), 16)
  const ch = (shift) => Math.round(((n >> shift) & 255) * (1 - amount))
  return '#' + [16, 8, 0].map((s) => ch(s).toString(16).padStart(2, '0')).join('')
}

// location_config -> { '--lj-…': value } for the colours the agency set. Text colours the
// agency did not set (or that are unreadable) are chosen for contrast.
export function agencyThemeVars(config = {}) {
  const vars = {}
  const action = color(config.button_bg_color)
  if (action) {
    vars['--lj-action'] = action
    vars['--lj-action-hover'] = shade(action)
    vars['--lj-focus'] = action
    vars['--lj-on-action'] = getReadableTextColor(action, color(config.button_text_color) || undefined)
  }
  const page = color(config.page_bg_color)
  if (page) vars['--lj-canvas'] = page
  const card = color(config.card_bg_color)
  if (card) {
    vars['--lj-surface'] = card
    vars['--lj-surface-ink'] = getReadableTextColor(card, color(config.card_text_color) || undefined)
  }
  // The studio sidebar is white; text chosen for the old purple sidebar (often white)
  // would vanish, so it is only used when it reads on white.
  const navInk = color(config.sidenav_text_color)
  if (navInk) vars['--lj-nav-ink'] = getReadableTextColor(NAV_BG, navInk)
  const navActive = color(config.sidenav_button_bg_color)
  if (navActive) {
    vars['--lj-nav-active'] = navActive
    vars['--lj-nav-active-ink'] = getReadableTextColor(navActive, color(config.sidenav_button_text_color) || undefined)
  }
  return vars
}

const APPLIED = []

// Sets the agency's overrides on <html>, removing any from a previous agency.
export function applyAgencyTheme(config, root = document.documentElement) {
  for (const name of APPLIED.splice(0)) root.style.removeProperty(name)
  for (const [name, value] of Object.entries(agencyThemeVars(config || {}))) {
    root.style.setProperty(name, value)
    APPLIED.push(name)
  }
}
